var map = {
	"./bg-card.svg": 5463,
	"./bx-calendar-alt.svg": 8948,
	"./bx-calendar-check.svg": 6234,
	"./bx-copy.svg": 5227,
	"./bx-message.svg": 2249,
	"./bx-note.svg": 1176,
	"./bx-receipt.svg": 8832,
	"./bx-smile.svg": 2240,
	"./bx-time-orange.svg": 3398,
	"./bx-user.svg": 7533,
	"./check.svg": 2743,
	"./customer.svg": 509,
	"./deposit-logo.svg": 2051,
	"./emoji-highfive.svg": 2226,
	"./emoji-not-satisfied.svg": 7594,
	"./emoji-quite-satisfied.svg": 3103,
	"./emoji-satisfied.svg": 2318,
	"./emoji-smile.svg": 7518,
	"./olsera-logo.svg": 8945,
	"./person.svg": 5554,
	"./receipt.svg": 8407,
	"./shipping.svg": 3839
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1533;